import React from 'react';
import '../styles/LegalPages.css';

const TermsOfService = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Terms of Service</h1>
        <p className="last-updated">Last updated: August 30, 2026</p>

        <section style={{ backgroundColor: '#fef2f2', border: '1px solid #fca5a5', borderRadius: '8px', padding: '16px 20px' }}>
          <h2 style={{ color: '#dc2626', marginTop: 0 }}>⚠️ Service Closure Notice</h2>
          <p>
            <strong>Effective October 1, 2026</strong>, Property ROI (propertyroi.io) will be permanently closed. All registered user accounts, saved data, search history, and property analyses will no longer be accessible after this date.
          </p>
          <p>
            If you have an active paid subscription, no further charges will be made after the closure date. We recommend that you export or save any analyses or data you wish to retain before October 1, 2026.
          </p>
          <p>
            We thank you for using Property ROI. If you have any questions, please contact us at support@propertyroi.io.
          </p>
        </section>

        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing and using Property ROI and or propertyroi.io ("the Service"), operated by METRICBRIDGE, LLC ("Company," "we," "our," or "us"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service. This Agreement may be modified at any time by Company upon posting of the modified agreement. Any such modifications shall be effective immediately. You can view the most recent version of these terms at any time at https://propertyroi.io/terms. Each use by you shall constitute and be deemed your unconditional acceptance of this Agreement.
          </p>
        </section>

        <section>
          <h2>2. Privacy</h2>
          <p>
            Your visit to our site is also governed by our Privacy Policy. Please review our Privacy Policy at https://propertyroi.io/privacy, which is incorporated into these Terms by reference. By using the Service, you consent to the collection and use of your information as outlined in our Privacy Policy.
          </p>
        </section>

        <section>
          <h2>3. Ownership</h2>
          <p>
            This site is and shall continue to be the property of Company or its suppliers and is protected under applicable copyright, patent, trademark, and other proprietary rights. Any copying, redistribution, use or publication by you of any part of this site is prohibited, except as expressly permitted in this Agreement. Under no circumstances will you acquire any ownership rights or other interest in the Site by or through your use of the Site. Company reserves the right to change, add, or remove any features of the Service, in Company's sole discretion, and with, or without, any notification to you.
          </p>
        </section>

        <section>
          <h2>4. Site Use</h2>
          <p>
            Company grants you a limited, revocable, nonexclusive license to use this site solely for your own personal use and not for republication, distribution, assignment, sublicense, sale, preparation of derivative works, or other use. You agree not to copy the site, reverse engineer or break into the site, or use materials, products or services in violation of any law. The use of this website is at the discretion of Company and Company may terminate your use of this website at any time.
          </p>
        </section>

        <section>
          <h2>5. Compliance with Laws</h2>
          <p>
            You agree to comply with all applicable laws regarding your use of the website. You further agree that information provided by you is truthful and accurate to the best of your knowledge.
          </p>
        </section>

        <section>
          <h2>6. Indemnification</h2>
          <p>
            You agree to indemnify, defend and hold Company and our partners, employees, and affiliates, harmless from any liability, loss, claim and expense, including reasonable attorney's fees, related to your violation of this Agreement or use of the Site.
          </p>
        </section>

        <section>
          <h2>7. Disclaimer</h2>
          <p>
            THE INFORMATION ON THIS SITE IS PROVIDED ON AN "AS IS," "AS AVAILABLE" BASIS. YOU AGREE THAT USE OF THIS SITE IS AT YOUR SOLE RISK. Company DISCLAIMS ALL WARRANTIES OF ANY KIND, INCLUDING BUT NOT LIMITED TO ANY EXPRESS WARRANTIES, STATUTORY WARRANTIES, AND ANY IMPLIED WARRANTIES OF: MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. TO THE EXTENT YOUR JURISDICTION DOES NOT ALLOW LIMITATIONS ON WARRANTIES, THIS LIMITATION MAY NOT APPLY TO YOU. YOUR SOLE AND EXCLUSIVE REMEDY RELATING TO YOUR USE OF THE SITE SHALL BE TO DISCONTINUE USING THE SITE.
          </p>
        </section>

        <section>
          <h2>8. Use of Information</h2>
          <p>
            Company reserves the right, and you authorize us, to use and assign all information regarding site uses by you and all information provided by you in any manner consistent with our Privacy Policy.
          </p>
        </section>

        <section>
          <h2>9. Description of Service</h2>
          <p>
            Property ROI is a web application operated by METRICBRIDGE, LLC that provides real estate investment analysis tools, including property valuation, ROI calculations, market analysis, property comparison features, and AI-powered chat assistance. The Service offers both free and premium subscription tiers with varying levels of functionality. The service is accessible in the US only and for properties located in the US only, and is not accessible from any other country or for properties outside the US.
          </p>
        </section>

        <section>
          <h2>10. AI-Powered Features</h2>
          <p>
            Our chat feature utilizes Anthropic's Claude AI service to provide property-related assistance and information. By using the chat functionality, you acknowledge that your messages will be processed by Anthropic's systems in accordance with their privacy policy. AI-generated responses are for informational purposes only and should not be considered as professional financial, legal, or investment advice.
          </p>
        </section>

        <section>
          <h2>11. User Accounts</h2>
          <p>
            To access certain features of the Service, you must create an account. You are responsible for:
          </p>
          <ul>
            <li>Maintaining the confidentiality of your account credentials</li>
            <li>All activities that occur under your account</li>
            <li>Providing accurate and complete information during registration</li>
            <li>Promptly updating your account information if it changes</li>
          </ul>
        </section>

        <section>
          <h2>12. Subscription Plans and Payments</h2>
          <p>
            The Service offers multiple subscription tiers:
          </p>
          <ul>
            <li><strong>Free Tier:</strong> Limited to 5 property analyses and 10 chat messages per month</li>
            <li><strong>Premium Tier:</strong> 50 property analyses and 500 chat messages per month with enhanced features</li>
            <li><strong>Pro Tier:</strong> 500 property analyses and 1000 chat messages per month with full access to all features</li>
          </ul>
          <p>
            Subscription fees are billed monthly and are non-refundable. You may cancel your subscription at any time, but cancellation will take effect at the end of the current billing period.
          </p>
        </section>

        <section>
          <h2>13. Acceptable Use</h2>
          <p>You agree not to:</p>
          <ul>
            <li>Use the Service for any unlawful purpose or in violation of any local, state, national, or international law</li>
            <li>Transmit or upload any content that infringes upon another party's intellectual property rights</li>
            <li>Attempt to gain unauthorized access to the Service or its related systems</li>
            <li>Use automated systems to access the Service in a manner that sends more request messages to our servers than a human can reasonably produce</li>
            <li>Share your account credentials with others or allow others to use your account</li>
          </ul>
        </section>

        <section>
          <h2>14. Third-Party Data Processing</h2>
          <p>The Service integrates with third-party providers for various functionalities:</p>
          <ul>
            <li>Anthropic's Claude AI for chat features - your chat messages are processed by Anthropic</li>
            <li>Stripe for payment processing - payment data is handled by Stripe</li>
            <li>AWS services for hosting and data storage</li>
            <li>Property data providers for real estate information</li>
          </ul>
          <p>
            By using these features, you acknowledge that your data may be shared with and processed by these third-party providers in accordance with their respective privacy policies.
          </p>
        </section>

        <section>
          <h2>15. Property Data and Analysis</h2>
          <p>
            The Service provides property analysis based on publicly available data and user inputs. You acknowledge that:
          </p>
          <ul>
            <li>Property data may not always be current or completely accurate</li>
            <li>Analysis results are estimates and should not be considered as professional financial, legal, or investment advice</li>
            <li>AI-generated responses may contain errors and should be independently verified</li>
            <li>You should conduct your own due diligence before making any investment decisions</li>
            <li>We are not liable for investment decisions made based on our analysis or AI-generated content</li>
            <li>The Service is for informational and educational purposes only</li>
          </ul>
        </section>

        <section>
          <h2>16. Investment Disclaimer</h2>
          <p>
            The calculations, analysis, and information provided by the Service, including AI-generated content, are for informational purposes only and do not constitute financial, investment, legal, tax, or other professional advice. Real estate investments involve substantial risk, and past performance does not guarantee future results. You should perform appropriate, comprehensive due diligence in considering any real estate purchase, and should consult with qualified professionals before making any real estate purchase or investment decisions.
          </p>
        </section>

        <section>
          <h2>17. Intellectual Property</h2>
          <p>
            The Service and its original content, features, and functionality are owned by METRICBRIDGE, LLC and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.
          </p>
        </section>

        <section>
          <h2>18. Disclaimer of Warranties</h2>
          <p>
            The Service is provided on an "AS IS" and "AS AVAILABLE" basis. We make no warranties, expressed or implied, and hereby disclaim all warranties including, without limitation, implied warranties of merchantability, fitness for a particular purpose, or non-infringement of intellectual property.
          </p>
        </section>

        <section>
          <h2>19. Limitation of Liability</h2>
          <p>
            UNDER NO CIRCUMSTANCES WILL Company BE LIABLE OR RESPONSIBLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, CONSEQUENTIAL (INCLUDING DAMAGES FROM LOSS OF BUSINESS, LOST PROFITS, LITIGATION, OR THE LIKE), SPECIAL, EXEMPLARY, PUNITIVE, OR OTHER DAMAGES, UNDER ANY LEGAL THEORY, ARISING OUT OF OR IN ANY WAY RELATING TO THE SITE, YOUR SITE USE, OR THE CONTENT, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. YOUR SOLE REMEDY FOR DISSATISFACTION WITH THE SITE AND/OR CONTENT IS TO CEASE ALL OF YOUR SITE USE.
          </p>
          <p>
            You may have additional rights under certain laws (including consumer laws) which do not allow the exclusion of implied warranties, or the exclusion or limitation of certain damages. If these laws apply to you, the exclusions or limitations in this Agreement that directly conflict with such laws may not apply to you.
          </p>
        </section>

        <section>
          <h2>20. Termination</h2>
          <p>
            We may terminate or suspend your account and bar access to the Service immediately, without prior notice or liability, under our sole discretion, for any reason whatsoever, including without limitation if you breach the Terms.
          </p>
        </section>

        <section>
          <h2>21. Changes to Terms</h2>
          <p>
            We reserve the right to modify or replace these Terms at any time. If a revision is material, we will provide at least 30 days notice prior to any new terms taking effect. Your continued use of the Service after any such changes constitutes your acceptance of the new Terms.
          </p>
        </section>

        <section>
          <h2>22. Governing Law</h2>
          <p>
            You agree that the laws of the state of Washington, without regard to conflicts of laws provisions will govern these Terms and Condition of Use and any dispute that may arise between you and Company or its affiliates.
          </p>
          <p>
            Any action or proceeding related to or arising out of any dispute between you and Company or its affiliates shall be brought and maintained exclusively in a court of competent jurisdiction in the County of Snohomish County, Washington.
          </p>
        </section>

        <section>
          <h2>23. Severability</h2>
          <p>
            If any provision of this Agreement shall be adjudged by any court of competent jurisdiction to be unenforceable or invalid, that provision shall be limited or eliminated to the minimum extent necessary so that this Agreement will otherwise remain in full force and effect.
          </p>
        </section>

        <section>
          <h2>24. Contact Information</h2>
          <p>
            If you have any questions about these Terms of Service, please contact us at:
          </p>
          <p>
            Email: support@propertyroi.io
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsOfService;